import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { captureError } from '../../utils/capture-error';
import {
  AllianceErrorBoundary,
  isChunkLoadError,
} from '../alliance/error-boundary';
import { AppUpdatedScreen, CrashScreen } from '../alliance/system-screens';

/**
 * Catches render errors in a route. The shell (App Bar) stays usable
 * and the page shows the inline crash screen. A lazy chunk that failed to
 * load after a deploy shows "ARC has been updated" with Reload instead.
 * Navigating to another route clears the error.
 */
export function RouteErrorBoundary(props: { children: React.ReactNode }) {
  // Hooks
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <AllianceErrorBoundary
      resetKey={location.pathname}
      onError={(error, errorInfo) =>
        captureError({ data: { error, errorInfo } })
      }
      fallback={({ error, reset }) =>
        isChunkLoadError(error) ? (
          <AppUpdatedScreen />
        ) : (
          <CrashScreen
            layout="inline"
            onRetry={reset}
            onHome={() => {
              navigate('/home');
              reset();
            }}
          />
        )
      }
    >
      {props.children}
    </AllianceErrorBoundary>
  );
}
